import { useMemo } from "react";
import ICONS from "../../../../assets/Icons";
import TickerAnimation from "../../TickerAnimation";

const normalize = (value = "") => value.trim().toLowerCase();

const SingleOptionSelector = ({
  options = [],
  selectedOption = null,
  metaMap = {},
  iconResolver = () => "",
  onSelect = () => {},
  previewMode = false,
  title = "",
  subTitle = "",
  showIcon = true,
  isSectionType = false,
  getLabel = (item) => item?.name || item || "",
  getKey = (item) => normalize(getLabel(item)),
  shouldHideCheckbox,
}) => {
  const selectedKey = useMemo(
    () => normalize(selectedOption?.name || getLabel(selectedOption)),
    [selectedOption, getLabel],
  );

  const resolveMeta = (item) => {
    const key = getKey(item);
    return metaMap[key] || {};
  };

  if (previewMode && selectedOption) {
    const label = getLabel(selectedOption);
    const meta = resolveMeta(selectedOption);
    const description = meta.description || "";

    return (
      <div className="w-width-full bg-primary-card rounded-border-radius-md p-padding-md text-text-primary">
        <p className="text-left font-semibold text-base mb-margin-md">
          {title}
        </p>

        <div
          className={`bg-primary-nav rounded-border-radius-md flex ${!showIcon && "rounded-l-border-radius-md pl-padding-sm"}`}
        >
          {showIcon && (
            <div className="bg-text-primary p-padding-sm flex items-center justify-center rounded-l-border-radius-md">
              <img
                className="w-icon-lg h-icon-lg"
                src={
                  iconResolver(label, meta, selectedOption) ||
                  ICONS?.DEFAULT_ICON
                }
                alt={label}
              />
            </div>
          )}

          <div className="flex flex-col justify-center flex-1 pr-padding-md pl-padding-sm py-padding-sm rounded-r-border-radius-md w-width-full">
            <div className="text-text-primary font-semibold text-sm">
              <TickerAnimation text={label} />
            </div>

            {description && (
              <div className="text-text-primary text-xs mt-margin-xs w-width-full">
                <TickerAnimation text={description} />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-width-full lg:max-w-[var(--create-box-width)]">
      <div className="bg-primary-nav flex flex-col rounded-border-radius-md">
        <div className="bg-primary-card rounded-t-border-radius-md px-padding-md pt-padding-md">
          <p className="text-text-primary font-semibold text-base">{title}</p>

          {subTitle && (
            <p className="text-text-secondary text-xs mt-margin-xs">
              {subTitle}
            </p>
          )}
        </div>

        <div className="bg-primary-card py-padding-md rounded-b-border-radius-md w-width-full">
          <div className="flex flex-col gap-gap-md px-padding-md pb-padding-md max-h-single-selector overflow-y-auto">
            {options.map((item, index) => {
              const label = getLabel(item);
              const key = getKey(item);
              const meta = resolveMeta(item);
              const description = meta.description || "";
              const isSelected = key === selectedKey;
              const isDisabled = item?.disabled === true;

              return (
                <div className="flex flex-col gap-gap-md cursor-pointer w-width-full">
                  <div
                    key={index}
                    className={`rounded-border-radius-md overflow-hidden flex items-center w-width-full ${
                      isDisabled
                        ? "opacity-light-opacity cursor-not-allowed"
                        : "cursor-pointer"
                    }`}
                    onClick={() => {
                      if (!isDisabled) onSelect(item);
                    }}
                    style={
                      isSectionType
                        ? undefined
                        : { background: "var(--category-background)" }
                    }
                  >
                    {showIcon && (
                      <div className="p-padding-sm flex items-center justify-center rounded-l-border-radius-md">
                        <img
                          className="w-icon-lg h-icon-lg flex-shrink-0"
                          src={
                            iconResolver(label, meta, item) ||
                            ICONS?.DEFAULT_ICON
                          }
                          alt="icon"
                        />
                      </div>
                    )}

                    <div
                      className={`flex relative z-z-index-base rounded-r-border-radius-md flex-1 items-center overflow-hidden ${
                        isDisabled
                          ? "bg-primary-nav"
                          : isSelected
                            ? "bg-positive-card global-hover-black"
                            : "bg-primary-nav global-hover-white"
                      }`}
                    >
                      <div
                        className={`Qmd:w-width_xl w-width-md relative z-z-index-base flex flex-col gap-gap-xs items-center justify-between flex-1 pr-padding-md py-padding-sm transition-colors duration-animation-fast-s ${isSectionType ? "pl-padding-md" : "pl-padding-sm"}`}
                      >
                        <div className="w-width-full text-text-primary font-semibold text-sm break-all pr-padding-xs">
                          <TickerAnimation text={label} />
                        </div>

                        {description && (
                          <div className="w-width-full text-text-primary text-xs pr-padding-xs break-all">
                            <TickerAnimation text={description} />
                          </div>
                        )}
                      </div>

                      {!shouldHideCheckbox && (
                        <div className="pr-padding-md py-padding-md relative z-z-index-header">
                          <img
                            className="w-icon-md h-icon-md"
                            src={
                              isSelected
                                ? ICONS.RADIO_BUTTON_SELECTED
                                : ICONS.RADIO_BUTTON_NOT_SELECTED
                            }
                            alt="radio"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (!isDisabled) onSelect(item);
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  {/* {enableSearch &&
                    searchText &&
                    filteredAssigned.length ===
                      GlobalConfiguration?.lengthCheckZero && (
                      <p className="text-text-secondary text-font-xs">
                        {TEXT?.NO_ASSIGNED_CATEGORIES_FOUND}
                      </p>
                    )} */}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleOptionSelector;
